import axios from "axios";

const geoAPI = axios.create();

geoAPI.interceptors.request.use((config) => {
  config.headers!.AUTHORIZATION = `Bearer ${sessionStorage.getItem('REDIRECT::INFO') || new URLSearchParams(window.location.search).get('token') || ''}`;
  config.headers!.LANG = localStorage.getItem("LANGUAGE") || "";
  config.headers!.ENVIRONMENT = sessionStorage.getItem("ENV") || "";
  return config;
});

export default geoAPI;